import React from "react";
import { AlertTriangle, X } from "lucide-react";

interface WarningNoticeProps {
  message: string;
  tip?: string;
  className?: string;
  onDismiss?: () => void;
  dismissLabel?: string;
  dismissAriaLabel?: string;
}

const WarningNotice: React.FC<WarningNoticeProps> = ({ 
    message,
    tip,
    className = "",
    onDismiss,
    dismissLabel,
    dismissAriaLabel,
}) => {
  const ariaLabel = dismissAriaLabel || dismissLabel || "Dismiss";

  return (
    <div className={`p-3 bg-yellow-50 dark:bg-yellow-900/40 rounded-md border border-yellow-200 dark:border-yellow-700 ${className}`}>
      <div className="flex items-start space-x-2">
        <AlertTriangle className="h-4 w-4 text-yellow-800 dark:text-yellow-400 mt-0.5 flex-shrink-0" />
        <div className="flex-1 min-w-0">
          <p className="text-sm text-yellow-800 dark:text-yellow-400">
            {message}
          </p>
          {tip && (
            <p className="text-xs text-yellow-800/80 dark:text-yellow-400/80 mt-1">
              {tip}
            </p>
          )}
        </div>
        {onDismiss && (
          dismissLabel ? (
            <button
              type="button"
              onClick={onDismiss}
              className="text-sm font-medium text-yellow-800 hover:text-yellow-900 dark:text-yellow-400 dark:hover:text-yellow-300 flex-shrink-0 underline-offset-2 hover:underline"
              aria-label={ariaLabel}
            >
              {dismissLabel}
            </button>
          ) : (
            <button
              type="button"
              onClick={onDismiss}
              className="text-yellow-800 hover:text-yellow-900 dark:text-yellow-400 dark:hover:text-yellow-300 flex-shrink-0 p-0.5"
              aria-label={ariaLabel}
            >
              <X className="h-4 w-4" />
            </button>
          )
        )}
      </div>
    </div>
  );
};

export default WarningNotice;
